import { pipe } from "fp";
import { creator, reducer, type } from "~/Action";

// eslint-disable-next-line functional/prefer-readonly-type
export type DriverId = number

export namespace State {
  export type State = DriverId;
  export const initial = (): State => -1;
}

export namespace Action {
  export namespace Updated {
    export const { TYPE, create, reduce } = pipe(
      type("Driver id filter updated" as const),
      creator((driverId: DriverId) => {
        return { driverId: driverId };
      }),
      reducer(({ state, action: { driverId } }) => {
        return (state.drivers.driverId = driverId);
      })
    );
  }
}
